import React from 'react';

import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Message from 'components/Message';
import { TooltipContent, TooltipToggle } from 'components/Tooltip';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { skuSharedMessages } from '../shared/SkuOrder.messages';

import messages from './SkuOrderDashboard.messages';

const { element } = bem('sku-orders-dashboard');

export const OrderTableHeader = () => (
  <tr>
    <th>
      <Message message={messages.columnMemberName} />
    </th>
    <th>
      <Message message={messages.columnOrderId} />
    </th>
    <th>
      <Message message={messages.columnItem} />
    </th>
    <th className={element('th-payout')}>
      <span className={element('table-th-payout')}>
        <Message message={messages.columnPayout} />
        <TooltipToggle name="sku-orders-payout" className={element('payout-info-icon')}>
          <Isvg src={ICONS.infoGreyLight} />
        </TooltipToggle>
        <TooltipContent name="sku-orders-payout" place="top">
          <Message message={skuSharedMessages.payableAmountTooltip} />
        </TooltipContent>
      </span>
    </th>
    <th className={element('th-right')}>
      <Message message={messages.columnOrderPlaced} />
    </th>
    <th className={element('th-right')}>
      <Message message={messages.columnPickupTime} />
    </th>
    <th className={element('th-center')}>
      <span className={element('status-header-label')}>
        <Message message={messages.columnStatus} />
      </span>
    </th>
  </tr>
);

export const MobileOrderTableHeader = () => (
  <tr>
    <th>
      <Message message={messages.columnOrderId} />
    </th>
    <th className={element('th-center')}>
      <span className={element('status-header-label')}>
        <Message message={messages.columnStatus} />
      </span>
    </th>
  </tr>
);

export const CellValue = ({ value, align, emphasis = false }) => {
  const isEmpty = value === null || value === undefined || value === '';
  const displayValue = isEmpty ? '--' : value;

  return <span className={element('cell-value', { empty: isEmpty, emphasis, [align]: !!align })}>{displayValue}</span>;
};

CellValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.oneOf(['right']),
  emphasis: PropTypes.bool,
};
